module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "position-relative p-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "7"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.tripLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'loading-blur': _vm.tripLoading
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0"
  }, [_c('md-icon', {
    staticClass: "mr-2 text-primary",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("location_on")]), _vm._v(" TOP USED LOCATIONS / HUBS\n            ")], 1), _vm._v(" "), _c('b-form-radio-group', {
    staticClass: "role-selector-pills",
    attrs: {
      "options": _vm.roleOptions,
      "buttons": "",
      "size": "sm",
      "button-variant": "outline-primary"
    },
    on: {
      "change": function($event) {
        _vm.$emit('role-change', $event)
      }
    },
    model: {
      value: (_vm.selectedRole),
      callback: function($$v) {
        _vm.selectedRole = $$v
      },
      expression: "selectedRole"
    }
  })], 1), _vm._v(" "), _c('apexchart', {
    attrs: {
      "type": "bar",
      "height": "380",
      "options": _vm.tripTrendsOptions,
      "series": _vm.tripTrendsSeries
    }
  })], 1)])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 border-0 position-relative overflow-hidden glass-card h-100",
    attrs: {
      "shadow-sm": ""
    }
  }, [(_vm.densityLoading) ? _c('div', {
    staticClass: "loading-overlay"
  }, [_c('b-spinner', {
    attrs: {
      "small": "",
      "variant": "primary"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex flex-column h-100",
    class: {
      'loading-blur': _vm.densityLoading
    }
  }, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0 text-uppercase"
  }, [_c('md-icon', {
    staticClass: "mr-2 text-info",
    attrs: {
      "size": "18"
    }
  }, [_vm._v("local_shipping")]), _vm._v(" VEHICLES PER HUB (DENSITY)\n            ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive flex-grow-1"
  }, [_c('table', {
    staticClass: "table custom-density-table mb-0"
  }, [_c('thead', [_c('tr', {
    staticClass: "bg-light-soft text-muted text-uppercase xs-font"
  }, [_c('th', {
    staticClass: "border-0 font-weight-bold"
  }, [_vm._v("Hub / Location")]), _vm._v(" "), _c('th', {
    staticClass: "border-0 font-weight-bold text-center"
  }, [_vm._v("Active Veh.")]), _vm._v(" "), _c('th', {
    staticClass: "border-0 font-weight-bold text-right"
  }, [_vm._v("Avg Turnaround")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.densityData), function(item, index) {
    return _c('tr', {
      key: index,
      staticClass: "align-middle"
    }, [_c('td', {
      staticClass: "border-0 py-3"
    }, [_c('div', {
      staticClass: "font-weight-bold text-dark"
    }, [_vm._v(_vm._s(item.location))]), _vm._v(" "), _c('div', {
      staticClass: "xs-font text-muted text-uppercase"
    }, [_vm._v(_vm._s(item.region))])]), _vm._v(" "), _c('td', {
      staticClass: "border-0 py-3 text-center"
    }, [_c('b-badge', {
      staticClass: "density-badge px-3 py-1",
      attrs: {
        "pill": "",
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(item.activeVehicles))])], 1), _vm._v(" "), _c('td', {
      staticClass: "border-0 py-3 text-right"
    }, [_c('span', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(item.avgTurnaround))])])])
  }), _vm._v(" "), (!_vm.densityData || _vm.densityData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center py-5 text-muted small",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No hub density data available")])]) : _vm._e()], 2)])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-609510bc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/VehiclePerformanceDashboard/components/LocationIntelligenceTab.vue
// module id = 2676
// module chunks = 0